import React, { Suspense, lazy } from 'react';
import { useFormContext, STEP_IDS } from './FormContext';
// Lazy load components to improve initial load time
const WelcomeScreen = lazy(() => import('./WelcomeScreen').then(module => ({
  default: module.WelcomeScreen
})));
const SuccessScreen = lazy(() => import('./SuccessScreen').then(module => ({
  default: module.SuccessScreen
})));
const ProjectTypeStep = lazy(() => import('./steps/ProjectTypeStep').then(module => ({
  default: module.ProjectTypeStep
})));
const DimensionsStep = lazy(() => import('./steps/DimensionsStep').then(module => ({
  default: module.DimensionsStep
})));
const ColorStep = lazy(() => import('./steps/ColorStep').then(module => ({
  default: module.ColorStep
})));
const RoofMaterialStep = lazy(() => import('./steps/RoofMaterialStep').then(module => ({
  default: module.RoofMaterialStep
})));
const ExtraElementsStep = lazy(() => import('./steps/ExtraElementsStep').then(module => ({
  default: module.ExtraElementsStep
})));
const SchuifwandTypeStep = lazy(() => import('./steps/SchuifwandTypeStep').then(module => ({
  default: module.SchuifwandTypeStep
})));
const SchuifwandColorStep = lazy(() => import('./steps/SchuifwandColorStep').then(module => ({
  default: module.SchuifwandColorStep
})));
const CarportRoofStep = lazy(() => import('./steps/CarportRoofStep').then(module => ({
  default: module.CarportRoofStep
})));
const CarportColorStep = lazy(() => import('./steps/CarportColorStep').then(module => ({
  default: module.CarportColorStep
})));
const TuinbestratingDetailsStep = lazy(() => import('./steps/TuinbestratingDetailsStep').then(module => ({
  default: module.TuinbestratingDetailsStep
})));
const SchuttingDetailsStep = lazy(() => import('./steps/SchuttingDetailsStep').then(module => ({
  default: module.SchuttingDetailsStep
})));
const ZandcementDetailsStep = lazy(() => import('./steps/ZandcementDetailsStep').then(module => ({
  default: module.ZandcementDetailsStep
})));
const PersonalDetailsStep = lazy(() => import('./steps/PersonalDetailsStep').then(module => ({
  default: module.PersonalDetailsStep
})));
const SummaryStep = lazy(() => import('./steps/SummaryStep').then(module => ({
  default: module.SummaryStep
})));
// Loading placeholder
const LoadingPlaceholder = () => <div className="p-8 md:p-10 flex items-center justify-center min-h-[400px]" data-id="element-802">
    <div className="animate-pulse flex flex-col items-center" data-id="element-803">
      <div className="w-12 h-12 bg-white/20 rounded-full mb-4" data-id="element-804"></div>
      <div className="h-4 bg-white/20 rounded w-48 mb-2" data-id="element-805"></div>
      <div className="h-3 bg-white/10 rounded w-36" data-id="element-806"></div>
    </div>
  </div>;
export const StepRenderer: React.FC = () => {
  const {
    currentStep,
    formSubmitted,
    resetForm
  } = useFormContext();
  // Show success screen if form is submitted
  if (formSubmitted) {
    return <Suspense fallback={<LoadingPlaceholder data-id="element-808" />} data-id="element-807">
        <SuccessScreen onReset={resetForm} data-id="element-809" />
      </Suspense>;
  }
  // Render the appropriate step based on currentStep
  return <Suspense fallback={<LoadingPlaceholder data-id="element-811" />} data-id="element-810">
      {(() => {
      switch (currentStep) {
        case STEP_IDS.WELCOME:
          return <WelcomeScreen data-id="element-812" />;
        case STEP_IDS.PROJECT_TYPE:
          return <ProjectTypeStep data-id="element-813" />;
        case STEP_IDS.DIMENSIONS:
          return <DimensionsStep data-id="element-814" />;
        case STEP_IDS.COLOR:
          return <ColorStep data-id="element-815" />;
        case STEP_IDS.ROOF_MATERIAL:
          return <RoofMaterialStep data-id="element-816" />;
        case STEP_IDS.EXTRA_ELEMENTS:
          return <ExtraElementsStep data-id="element-817" />;
        case STEP_IDS.SCHUIFWAND_TYPE:
          return <SchuifwandTypeStep data-id="element-818" />;
        case STEP_IDS.SCHUIFWAND_COLOR:
          return <SchuifwandColorStep data-id="element-819" />;
        case STEP_IDS.CARPORT_ROOF:
          return <CarportRoofStep data-id="element-820" />;
        case STEP_IDS.CARPORT_COLOR:
          return <CarportColorStep data-id="element-821" />;
        case STEP_IDS.TUINBESTRATING_DETAILS:
          return <TuinbestratingDetailsStep data-id="element-822" />;
        case STEP_IDS.SCHUTTING_DETAILS:
          return <SchuttingDetailsStep data-id="element-823" />;
        case STEP_IDS.ZANDCEMENT_DETAILS:
          return <ZandcementDetailsStep data-id="element-824" />;
        case STEP_IDS.PERSONAL_DETAILS:
          return <PersonalDetailsStep data-id="element-825" />;
        case STEP_IDS.SUMMARY:
          return <SummaryStep data-id="element-826" />;
        default:
          return null;
      }
    })()}
    </Suspense>;
};